import React, { FC } from 'react';
import { create } from 'zustand';

const DEFAULT_QUIZ_ID = 'default';

export interface QuizStore {
  quizFeedback: Record<string, string>;
  getQuizFeedback: (quizId?: string) => string;
  setQuizFeedback: (feedback?: string, quizId?: string) => void;
  quizId: string;
  setQuizId: (id: string) => void;
  weNeedToUseOwnFeedback: boolean;
  setWeNeedToUseOwnFeedback: (value: boolean) => void;
}

export const useQuizStore = create<QuizStore>((set, get) => ({
  quizFeedback: {},
  getQuizFeedback: (quizId?: string) => {
    const feedbackObj = get().quizFeedback;

    if (!get().weNeedToUseOwnFeedback) {
      const feedbackKeys = Object.keys(feedbackObj);

      // If we have only one element, return it, ignoring quizId
      if (feedbackKeys.length === 1) {
        return feedbackObj[feedbackKeys[0]] || '';
      }
    }

    // If we have multiple elements, search by quizId
    const rawId = quizId || get().quizId || DEFAULT_QUIZ_ID;
    const id = typeof rawId === 'string' ? rawId : String(rawId);
    const tempId = id.includes('.') ? id.split('.').slice(0, -1).join('.') : '';

    return (tempId ? feedbackObj[tempId] : null) || feedbackObj[id] || '';
  },
  setQuizFeedback: (feedback, quizId) => {
    const feedbackKeys = Object.keys(get().quizFeedback);

    let rawId = DEFAULT_QUIZ_ID;

    if (!get().weNeedToUseOwnFeedback) {
      // we have issue with quiz feedback. If we have just only one quiz we don't need to use quiz group
      // If we have only one element, use DEFAULT_QUIZ_ID
      // If we have multiple elements, use the passed quizId
      rawId =
        feedbackKeys.length <= 1
          ? DEFAULT_QUIZ_ID
          : quizId || get().quizId || DEFAULT_QUIZ_ID;
    } else {
      // we have issue with quiz feedback. If we have just only one quiz we don't need to use quiz group
      // If we have only one element, use DEFAULT_QUIZ_ID
      // If we have multiple elements, use the passed quizId
      rawId = quizId || get().quizId || DEFAULT_QUIZ_ID;
    }

    const id = typeof rawId === 'string' ? rawId : String(rawId);

    set(state => ({
      quizFeedback: {
        ...state.quizFeedback,
        [id]: feedback || ''
      }
    }));
  },
  quizId: DEFAULT_QUIZ_ID,
  setQuizId: id => set({ quizId: id ? String(id) : DEFAULT_QUIZ_ID }),
  weNeedToUseOwnFeedback: false,
  setWeNeedToUseOwnFeedback: value => set({ weNeedToUseOwnFeedback: value })
}));

export const QuizProvider: FC<{ quizId: string }> = ({ children, quizId }) => (
  <>{children}</>
);
